import { VerticalContainer, useForm } from '@american-autonomy/ag-ui';

import Form from 'components/Form';
import FormSubmitPanel from 'components/FormSubmitPanel';
import DroneFormFields from 'components/forms/DroneFormFields';

import useDrone from 'hooks/useDrone';
import useFormDiscardConfirmation from 'hooks/useFormDiscardConfirmation';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props, UpdateDroneFormSchema } from './types';

import styles from './styles.module.scss';

const UpdateDroneForm: FunctionComponent<Props> = ({
    className = '',
    formValues,
    isClosing,
    onClose,
    setIsClosing,
    testId = TEST_ID
}) => {
    const { updateDrone } = useDrone();
    const { SAVE } = useTranslation();

    const form = useForm<UpdateDroneFormSchema>({
        defaultValues: formValues,
        mode: 'onChange'
    });

    const {
        formState: { errors, isDirty },
        handleSubmit
    } = form;

    const { confirmationPanel, showConfirmation } = useFormDiscardConfirmation({
        isDirty,
        onCancelClose: () => setIsClosing?.(false),
        onClose,
        requestingClose: isClosing
    });

    const onSubmit = async (data: UpdateDroneFormSchema) => {
        if (!formValues) {
            return;
        }

        await updateDrone({ drone: data, id: formValues.id });
        onClose?.();
    };

    return (
        <VerticalContainer className={`${styles.updateDroneForm} ${className}`} testId={testId}>
            {showConfirmation ? (
                confirmationPanel
            ) : (
                <Form className={styles.form} form={form}>
                    <DroneFormFields />

                    <FormSubmitPanel
                        buttonText={SAVE}
                        className={styles.formSubmitPanel}
                        errors={errors}
                        onSubmit={handleSubmit(onSubmit)}
                    />
                </Form>
            )}
        </VerticalContainer>
    );
};

export default UpdateDroneForm;
